export default __webpack_public_path__ + "static/henna-homepage-banner-desktop-ae42986c42bcd4cde884ad6beeddde44.webp";